import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthSnapshot } from '@/context/auth/deriveAuth';

export const Route = createFileRoute('/_authenticated/_onboarding')({
  beforeLoad: async () => {
    const { isOnboarded } = getAuthSnapshot();

    if (isOnboarded) {
      throw redirect({ to: '/' });
    }
  },
});
